// extracted by mini-css-extract-plugin
export var layout = "layout-module--layout--Ws604";
export var contentContainer = "layout-module--contentContainer--2-US4";